//Blog Progress Bar
/**
 * Sets progressbar based on the users scroll throughout the blog content.
 *
 * @param boolean [visibilityToggle] - Show/Hide progress bar when percentage is 100%
 * @param string [progressTarget] - The target content for the percentage value
 */
export function updateProgressBar(progressTarget = "#content", visibilityToggle = false) {
    const progressBar = document.querySelectorAll('.reading-progress .progress-bar');
    const content = document.querySelector(progressTarget);

    progressBar.forEach((el) => {
        if (!el || !content) return;

        const contentHeight = content.getBoundingClientRect().height;
        const contentTop = content.offsetTop;

        const calculateScrollPercent = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;

            // Start position (top of the content minus half the window height to account for starting mid-screen)
            const startScrollPos = contentTop - (windowHeight / 2);

            // End position (bottom of the content minus half the window height to account for ending mid-screen)
            const endScrollPos = contentTop + contentHeight - (windowHeight / 2);

            // Current scroll position, clamped between start and end positions
            const scrollPos = Math.min(Math.max(scrollPosition, startScrollPos), endScrollPos);

            // Scroll percentage (0 to 100)
            const scrollPercent = ((scrollPos - startScrollPos) / (endScrollPos - startScrollPos)) * 100;
            el.style.setProperty('--progress', `${scrollPercent}%`);

            if (visibilityToggle) {
                if (scrollPercent > 0 && scrollPercent < 100) {
                    el.style.visibility = 'visible';
                } else {
                    el.style.visibility = 'hidden';
                }
            }
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    window.addEventListener('scroll', calculateScrollPercent);
                    window.addEventListener('touchmove', calculateScrollPercent);
                    calculateScrollPercent();
                } else {
                    window.removeEventListener('scroll', calculateScrollPercent);
                    window.removeEventListener('touchmove', calculateScrollPercent);
                }
            });
        }, {
            root: null,
            threshold: 0,
        });

        observer.observe(content);
    });
}

/**
 * Generates a table of contents based on the headings in the content.
 *
 * @param string tags - CSS selector for the headings to include in the table of contents
 */
export function generate_toc(tags) {
    const toc = document.querySelector('#toc');
    const content = document.querySelector('#content');
    const headings = content.querySelectorAll(tags);
    const header = document.querySelector('#ig-main-site-header');
    const sidebar = document.querySelector('#sidebar');
    const blogContent = document.querySelector('#blog-post-main');

    if (!toc || !content || !headings || !sidebar) return;

    if (headings.length === 0) {
        toc.style.display = 'none';
        return;
    }

    if (header) {
        sidebar.style.top = `${header.getBoundingClientRect().height}px`;
    }

    blogContent.classList.add('sidebar-active');

    headings.forEach((heading, idx) => {
        if (!heading.id) {
            heading.id = `heading-${idx}`;
        }

        const list = document.createElement('li');
        const anchor = document.createElement('a');
        anchor.href = `#${heading.id}`;
        anchor.textContent = heading.textContent;
        anchor.classList.add(`toc-${heading.tagName.toLowerCase()}`);

        list.appendChild(anchor);
        toc.appendChild(list);
    });
}
